module.exports = __webpack_public_path__ + "static/media/cyuce0000.7d142396.jpg";